import React, { useEffect, useState } from 'react';

import { ConfirmDialog, Typography } from '@gogame/components';
import { useDateFormat } from '@gogame/intl-ts';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { createCampaign } from 'scenes/Campaigns/sources/campaigns';
import { loadAffiliates } from 'scenes/Campaigns/sources/fields';

import { moveToAnotherAffiliate } from '../queryKeyFactory';

export const useMoveToAnotherAffiliate = () => {
  const showModal = useScreenModalV2(ConfirmDialog);
  const mutation = useMutation(moveToAnotherAffiliate(), createCampaign, {
    successMessage: () => 'Moved to another affiliate',
  });

  const format = useDateFormat({
    template: 'do MMMM yyyy',
  });
  const [affiliates, setAffiliates] = useState([]);
  useEffect(() => {
    loadAffiliates().then(setAffiliates);
  }, []);

  const handleAction = async ({
    testCampaignId,
    testCampaignEndDate,
    ...other
  }) => {
    const campaign = {
      ...other,
      linkedCampaignInfo: {
        id: testCampaignId,
        date: testCampaignEndDate,
      },
    };
    const affiliateId = campaign.affiliateId;
    const affiliateLabel = affiliates?.find(
      ({ id }) => id === affiliateId
    )?.name;

    await showModal({
      title: 'Move Campaign to Another Affiliate?',
      confirmActionLabel: 'Move',
      children: (
        <Typography>
          As of {format(testCampaignEndDate)} selected campaign activity will be
          moved to be under "{affiliateLabel}" affiliate with the campaign name
          "{campaign?.campaigns?.[0].name}".
        </Typography>
      ),
    });

    const campaigns = await mutation.mutateAsync(campaign);
    return { campaigns, multiCampaign: campaign };
  };

  return [handleAction, mutation];
};
